module.exports = __webpack_public_path__ + "media/ring-billed-gull-2.baa91d13.mp3";